import _extends from "@babel/runtime/helpers/extends";
import { Box, Collapse, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { mergeWdsBoxColorProps, resolveWdsBoxColorProps, ThemeAwareIcon, wdsThemeColors } from '@wix/rules-panel-ui';
import { ChevronDownSmall, ChevronUpSmall } from '@wix/wix-ui-icons-common/on-stage';
import React, { useState } from 'react';
import { useA11yWizardAdapter } from '../../../hooks/use-a11y-wizard-adapter';
import { getRuleElementPropsFromCapabilities } from '../../../utils/get-fixer-design-props';
import { FailedElementItem } from './failed-element-item';
export const AffectedContainersList = _ref => {
  let {
    failedElements,
    onElementClick,
    onContainerClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const softIssueListSurfaces = capabilities.wizardPresentation.softIssueListSurfaces;
  const {
    hoveredBorderColor,
    notHoveredBorderColor
  } = getRuleElementPropsFromCapabilities(capabilities);
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  if (!failedElements || failedElements.length === 0) {
    return null;
  }
  const isContainerActive = isCollapseOpen || isHovered;
  const containerBorderColor = isContainerActive ? hoveredBorderColor : notHoveredBorderColor;
  const containerSurfaceProps = softIssueListSurfaces ? {
    border: '1px solid',
    ...mergeWdsBoxColorProps(resolveWdsBoxColorProps(notHoveredBorderColor, 'borderColor'), resolveWdsBoxColorProps(wdsThemeColors.surfaceNeutral), ...(isContainerActive ? [resolveWdsBoxColorProps(containerBorderColor, 'borderColor')] : []))
  } : {
    backgroundColor: isContainerActive ? 'D80' : 'D70',
    borderRadius: '10px'
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    borderRadius: softIssueListSurfaces ? '6px' : '10px',
    direction: "vertical",
    display: "flex",
    padding: "0 0 0 SP2"
  }, containerSurfaceProps), /*#__PURE__*/React.createElement(TextButton, {
    dataHook: "affected-containers-list-toggle",
    size: "tiny",
    skin: "dark",
    underline: "none",
    weight: "normal",
    fluid: true,
    onClick: () => {
      setIsCollapseOpen(!isCollapseOpen);
      onContainerClick == null || onContainerClick();
    },
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false)
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    cursor: "pointer",
    display: "flex",
    padding: "SP1",
    verticalAlign: "middle",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    secondary: true
  }, t('accessibility-wizard.rules-list.page-auto-dom-order.view-affected-containers.title', {
    count: failedElements.length
  })), /*#__PURE__*/React.createElement(ThemeAwareIcon, {
    color: wdsThemeColors.iconSecondary
  }, isCollapseOpen ? /*#__PURE__*/React.createElement(ChevronUpSmall, null) : /*#__PURE__*/React.createElement(ChevronDownSmall, null)))), /*#__PURE__*/React.createElement(Collapse, {
    open: isCollapseOpen
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    marginBottom: "SP2",
    marginTop: "SP2",
    paddingRight: "SP2"
  }, failedElements.map((element, index) => {
    const elementData = element;
    const displayName = elementData.semanticName;
    return /*#__PURE__*/React.createElement(FailedElementItem, {
      dataHook: `failed-element-${index}`,
      displayName: displayName,
      key: index,
      onViewClick: () => onElementClick == null ? void 0 : onElementClick(element, index)
    });
  }))));
};
//# sourceMappingURL=affected-containers-list.js.map